import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { deleteCompany } from '../requests';
import type { DeleteCompanyRequestType } from '../types';

export const useDeleteCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [API_QUERY_KEYS.companiesList],
    mutationFn: (id: DeleteCompanyRequestType['id']) =>
      deleteCompany({
        id,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.companiesList, API_QUERY_KEYS.companyGroups],
      });
    },
  });
};
